module.exports = __webpack_public_path__ + "img/app-icon-copy.0b7d7a3d.svg";